import queryString from 'query-string';

export const getAnonymousURLQueries = () => {
  const { isNewUser, redirectTo } = queryString.parse(window.location.search, {
    parseBooleans: true
  });

  return { isNewUser, redirectTo };
};
